/**
 * `resolve` - chooses one candidate per field by the spec's policy (see
 * `FieldPolicy`). May run more than once: a later step reads what the last
 * `resolve` chose.
 *
 * Options: `policy`. Needs nothing. Provides `resolved:<field>`.
 */

import { resolveFields, type ResolvePolicy } from '../resolve.js';
import { FIELD_KEYS, type Key, type Step } from '../types.js';

export interface ResolveOptions {
  policy: ResolvePolicy;
}

export const resolveStep: Step<ResolveOptions> = {
  name: 'resolve',
  needs: () => [],
  provides: (): Key[] => FIELD_KEYS.map((field) => `resolved:${field}`),
  async run(state, context) {
    const resolved = resolveFields(state, context.options.policy);
    const chosen = Object.fromEntries(Object.entries(resolved).map(([field, candidate]) => [field, candidate!.source]));
    return { resolved, chosen, added: [`${Object.keys(resolved).length} fields`] };
  },
};
